module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_der_Gemeinde_Wichtrach-58441bdbe475903ff318f0325570b461.svg";